// AI models as the Application API serves it (`GET /api/models`): what each model tier used of the Model Budget this
// month, whether any model call leaves India, and the data terms every model provider is held to. Milli-Credits.
import { call, type Fetch } from "../http.js";

export const MODEL_TIERS = ["T0", "T1", "T2", "T3"] as const;
export type ModelTier = (typeof MODEL_TIERS)[number];

export interface ModelsView {
  readonly month: string;
  readonly budgetMilliCredits: number;
  readonly usedMilliCredits: number;
  readonly remainingMilliCredits: number;
  readonly usedPercent: number;
  readonly tiers: readonly {
    readonly tier: ModelTier;
    /** Whether its model calls go outside the Cell, and India; T0 calls no model. */
    readonly leavesIndia: boolean;
    readonly count: number;
    readonly milliCredits: number;
  }[];
  readonly leavesIndia: boolean;
  readonly terms: { readonly noTraining: boolean; readonly zeroRetention: boolean };
}

export interface ModelsApi {
  view(): Promise<ModelsView>;
}

export const createModelsApi = (fetcher: Fetch): ModelsApi => ({
  view: () => call<ModelsView>(fetcher, "/api/models"),
});
